import { PageLayout } from '~/components/PageLayout/PageLayout';

export const Support = () => {
  return <PageLayout />;
};
